import { showSnackbar } from "../../Redux/action/SnackbarAction";

// Download any file type (image, pdf, excel, etc.) directly from the list.
// Cross-origin URLs can't use plain <a download>, so fetch as blob first and
// fall back to opening the file in a new tab if the fetch is blocked (CORS).
export const downloadFile = async (file, dispatch) => {
  const name = file.name || "download";
  const urlExt = file.url?.split("?")[0]?.split(".").pop();
  const downloadName =
    name.includes(".") || !urlExt || urlExt.length > 5
      ? name
      : `${name}.${urlExt}`;
  try {
    const response = await fetch(file.url);
    if (!response.ok) throw new Error("Download failed");
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = downloadName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    // Not every caller has redux to hand (the chat bubbles do not).
    if (dispatch) dispatch(showSnackbar("File downloaded", "success"));
  } catch (err) {
    console.error("Failed to download file:", err);
    window.open(file.url, "_blank", "noopener noreferrer");
  }
};
